import { graphql } from '../../gql';

export const ROLE_K17000_SELECTION_LIST = graphql(`
  query RoleK17000SelectionList($taxonomyId: CustomRoleTaxonomySelection!) {
    selectionList {
      role_taxonomy_k17000(taxonomy_id: $taxonomyId) {
        id
        role_k10
        role_k50
        role_k150
        role_k500
        role_k1500
        role_k15000
      }
    }
  }
`);
